/* This file was GENERATED from the Webflow capture, which has since been
 * retired — see DESIGN-SYSTEM-PLAN.md. There is no generator any more: this is
 * now ordinary source, and editing it by hand is how you change it.
 * Metadata only. Section bodies live in ./data/<slug>.ts and are loaded per
 * route, so no page carries the other sixteen.
 */

export interface PageMeta {
  route: string
  slug: string
  title: string
  description: string
  ogImage: string | null
}

export const PAGE_META: PageMeta[] = [
  {
    "route": "/",
    "slug": "home",
    "title": "Singulate | Every email, written for the person reading it",
    "description": "Singulate writes and designs your email, then fits it to each person on your list. Proven with enterprise teams, now open to anyone with a list.",
    "ogImage": "/media/og-singulate.png"
  },
  {
    "route": "/about",
    "slug": "about",
    "title": "About",
    "description": "The future of large-scale communication. Mind-blowing relevance personalization. The simplest way to segment audiences. Marketing automation made 90% easier with LLMs.",
    "ogImage": "/media/og-singulate.png"
  },
  {
    "route": "/agencies",
    "slug": "agencies",
    "title": "Agencies",
    "description": "Build highly segmented, personalized marketing nurtures for every client. Singulate helps agencies deliver precise, performance-driven campaigns faster.",
    "ogImage": null
  },
  {
    "route": "/ai-email-editor",
    "slug": "ai-email-editor",
    "title": "AI Email Platform",
    "description": "Build smart modules in seconds. Unlimited 1:1 personalization. Create rich HTML branded newsletters. Drag and drop interface, fully integrated with HubSpot. Instantly clean data and more.",
    "ogImage": null
  },
  {
    "route": "/data-cleanup",
    "slug": "data-cleanup",
    "title": "Data Cleanup",
    "description": "Transform any contact data just by typing. Wow Tags turn messy spreadsheet fields into clean, natural copy that fits your messaging — with fallback logic for every edge case.",
    "ogImage": null
  },
  {
    "route": "/demo",
    "slug": "demo",
    "title": "Get Demo",
    "description": "The future of large-scale communication. Mind-blowing relevance personalization. The simplest way to segment audiences. Marketing automation made 90% easier with LLMs. Coming soon.",
    "ogImage": "/media/og-singulate.png"
  },
  {
    "route": "/email-editor",
    "slug": "email-editor",
    "title": "Email Editor",
    "description": "Build beautiful marketing emails with your data. A drag-and-drop builder that puts data and messaging in one platform, with a library of smart templates.",
    "ogImage": null
  },
  {
    "route": "/events",
    "slug": "events",
    "title": "Events",
    "description": "Turn webinar and event data into hyper-personalized invites and follow-ups. Segment attendees by behavior, role, and engagement level to drive pipeline.",
    "ogImage": null
  },
  {
    "route": "/generative-content",
    "slug": "generative-content",
    "title": "Generative Content",
    "description": "Emails that adapt to every contact. Use a prompt for every paragraph to stop sending everyone the same thing and lift click rates at scale.",
    "ogImage": null
  },
  {
    "route": "/hubspot-integration",
    "slug": "hubspot-integration",
    "title": "HubSpot Email Personalization Integration | Singulate",
    "description": "Personalize HubSpot emails and workflows with Branched Content, Wow Tags, and Singulated Snippets. Keep your CRM, sending, and reporting in HubSpot.",
    "ogImage": null
  },
  {
    "route": "/hubspot-nurture-agent-vs-singulate",
    "slug": "hubspot-nurture-agent-vs-singulate",
    "title": "HubSpot Nurture Agent vs. Singulate: Feature Comparison | Singulate",
    "description": "HubSpot Nurture Agent and Singulate compared row by row: supported emails, controls, branching, data cleanup, previews, testing and cost, with screenshots.",
    "ogImage": null
  },
  {
    "route": "/lifecycle-marketing",
    "slug": "lifecycle-marketing",
    "title": "Lifecycle Marketing",
    "description": "Craft modular, data-powered messaging that adapts to every funnel stage. Turn dozens of lists and message variants into one email and save 40+ hours a week.",
    "ogImage": "/media/og-singulate.png"
  },
  {
    "route": "/marketing-automation",
    "slug": "marketing-automation",
    "title": "Marketing Automation",
    "description": "Seamless integration with HubSpot workflows. Clean data. Instant segmentation. Tracking and reporting stays in HubSpot. Modular design - built for hyper-personalized email nurtures.",
    "ogImage": null
  },
  {
    "route": "/modular-communication-strategy-architecture-whitepaper",
    "slug": "modular-communication-strategy-architecture-whitepaper",
    "title": "Introducing Modular Communication Strategy Architecture",
    "description": "The demand for highly relevant content has increased as marketers strive to deliver tailored messages that maximize performance (e.g., conversions, engagement) for each recipient. Over the years, various architectures have evolved to address this need, but each with certain limitations...",
    "ogImage": "/media/67dd53ef1d23a3557d60e95c_1400x700.jpg"
  },
  {
    "route": "/newsletter",
    "slug": "newsletter",
    "title": "P.S. Newsletter",
    "description": "The future of large-scale communication. Mind-blowing relevance personalization. The simplest way to segment audiences. Marketing automation made 90% easier with LLMs.",
    "ogImage": "/media/og-singulate.png"
  },
  {
    "route": "/privacy",
    "slug": "privacy",
    "title": "Privacy Policy",
    "description": "How Singulate collects, uses, shares, and protects your personal data across our websites, products, and services.",
    "ogImage": null
  },
  {
    "route": "/roi-calculator",
    "slug": "roi-calculator",
    "title": "Singulate ROI Calculator - See Your Email ROI",
    "description": "Calculate your potential ROI with Singulate. See how AI-powered email personalization can increase your open rates, click rates, and pipeline revenue.",
    "ogImage": null
  },
  {
    "route": "/sales",
    "slug": "sales",
    "title": "Sales",
    "description": "Send hyper-relevant outbound messaging for every persona, segment, and signal — without choosing between generic mass sends and manual personalization.",
    "ogImage": null
  },
  {
    "route": "/segmentation",
    "slug": "segmentation",
    "title": "Segmentation",
    "description": "Build precise audiences in seconds and turn 30 campaigns into one. Blazingly fast, always verified, and integrated with the stack you already run.",
    "ogImage": null
  },
  {
    "route": "/singulate-certified-partner-program",
    "slug": "singulate-certified-partner-program",
    "title": "Singulate Certified Partner Program",
    "description": "The future of large-scale communication. Mind-blowing relevance personalization. The simplest way to segment audiences. Marketing automation made 90% easier with LLMs. Coming soon.",
    "ogImage": "/media/og-singulate.png"
  },
  {
    "route": "/startups",
    "slug": "startups",
    "title": "Startups",
    "description": "Lean startups punch above their weight with AI-powered campaigns. Your GTM engineering partner for building pipeline without elaborate journey builds.",
    "ogImage": null
  },
  {
    "route": "/terms",
    "slug": "terms",
    "title": "Terms of Service",
    "description": "The rules and restrictions that govern your use of Singulate's websites, products, services, and applications. Effective September 30, 2026.",
    "ogImage": null
  },
  {
    "route": "/try-singulate-for-free",
    "slug": "try-singulate-for-free",
    "title": "Try Singulate for free",
    "description": "Join the Singulate Pilot Program — a free 2-month trial with full access to Singulate’s advanced personalization, onboarding, and a first campaign built with our team.",
    "ogImage": "/media/og-singulate.png"
  },
  {
    "route": "/studio",
    "slug": "studio",
    "title": "Singulate Studio | Personal emails for your business",
    "description": "Stay in touch with personal emails written and designed by Singulate. The Studio plan includes one seat and up to 3,000 emails a month. Try it free for 14 days.",
    "ogImage": null
  },
  {
    "route": "/pricing",
    "slug": "pricing",
    "title": "Pricing | Singulate",
    "description": "Studio is $49 a month at launch for up to 3,000 emails, each one written for the person reading it. Growth connects HubSpot and Instantly from $99. Enterprise adds your whole stack and a guarantee we never train on your data.",
    "ogImage": null
  },
  {
    "route": "/studio-for-jewelers",
    "slug": "studio-for-jewelers",
    "title": "Personalized Email Marketing for Independent Jewelers | Singulate",
    "description": "Bring past jewelry customers back with personal emails built from the details you already have. Create, review, and send with Singulate. Try it free for 14 days.",
    "ogImage": null
  },
  {
    "route": "/sendhelp",
    "slug": "sendhelp",
    "title": "Send Help: Chad Fixes Your Email Live | Singulate",
    "description": "Every Friday at noon ET, Chad goes live on Zoom, teaches one email lesson, then reworks the emails you send him, live. Free, thirty minutes.",
    "ogImage": null
  }
]

export const META_BY_ROUTE = new Map(PAGE_META.map((p) => [p.route, p]))
